module.exports = __webpack_public_path__ + "static/v7-94a815f55635b9f3a5c01d51c0898bc0.jpg";